var map = {
	"./ar.png": 1280,
	"./de.png": 1281,
	"./en.png": 1282,
	"./es.png": 1283,
	"./fr.png": 1284,
	"./he.png": 1285,
	"./hu.png": 1286,
	"./icons8-austria.png": 1287,
	"./icons8-canada.png": 1288,
	"./icons8-china.png": 1289,
	"./icons8-france.png": 1290,
	"./icons8-germany.png": 1291,
	"./icons8-hungary.png": 1292,
	"./icons8-india.png": 1293,
	"./icons8-israel.png": 1294,
	"./icons8-italy.png": 1295,
	"./icons8-japan.png": 1296,
	"./icons8-new_zealand.png": 1297,
	"./icons8-saudi_arabia.png": 1298,
	"./icons8-singapore.png": 1299,
	"./icons8-south_korea.png": 1300,
	"./icons8-usa.png": 1301,
	"./it.png": 1302,
	"./ja.png": 1303,
	"./ko.png": 1304,
	"./ru.png": 1305,
	"./zh.png": 1306
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 714;